import { Alert, Box, Snackbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function ImportResultAlert({ result, onClose }) {
  const theme = useTheme();

  if (!result) return null;

  const { createdCount, failed } = result;
  const total = createdCount + failed.length;
  const severity =
    failed.length === 0 ? "success" : createdCount === 0 ? "error" : "warning";
  const scrollbarThumb = theme.vars.palette[severity].main;

  const styles = {
    failedList: {
      m: 0,
      mt: 0.5,
      pl: 2.5,
      pr: 1.5,
      maxHeight: 200,
      overflowY: "auto",
      scrollbarColor: `${scrollbarThumb} transparent`,
      "&::-webkit-scrollbar-thumb": { backgroundColor: scrollbarThumb },
    },
  };

  return (
    <Snackbar open autoHideDuration={null} onClose={onClose}>
      <Alert severity={severity} onClose={onClose}>
        Imported {createdCount} of {total} initiative{total !== 1 ? "s" : ""}.
        {failed.length > 0 && (
          <Box component="ul" sx={styles.failedList}>
            {failed.map(({ item, message }, index) => (
              <Box component="li" key={index}>
                {item.title}: {message}
              </Box>
            ))}
          </Box>
        )}
      </Alert>
    </Snackbar>
  );
}
